import api from './api';

export default {
    async getInfoDashboard(token) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`
            };
            const response = await api.get(`/accounts/dashboard/`, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao fazer listagem de informações do dashboard:', error);
                throw error;
        }
    },
    async getContentStats(token) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`
            };
            const response = await api.get(`/accounts/content/stats`, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao fazer listagem de informações do dashboard:', error);
                throw error;
        }   
    }   
}

